import { useEffect, useState } from "react";

const KEY = "tilesphere_saved";

function read() {
    try {
        return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
        return [];
    }
}

export function useSaved() {
    const [saved, setSaved] = useState(read);

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(saved));
    }, [saved]);

    const toggle = (project) => {
        setSaved((prev) => {
            const exists = prev.find((p) => p.id === project.id);
            if (exists) return prev.filter((p) => p.id !== project.id);
            return [
                {
                    id: project.id,
                    slug: project.slug,
                    title: project.title,
                    thumbnail_url: project.thumbnail_url,
                    company_name: project.company_name,
                    room_type: project.room_type,
                },
                ...prev,
            ];
        });
    };

    const isSaved = (id) => saved.some((p) => p.id === id);

    return { saved, toggle, isSaved };
}
